import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import homeFaq from '../content/homeFaq';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = homeFaq;

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="intrebari" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Întrebări frecvente
            </h2>
            <p className="text-gray-600">
              Găsește răspunsuri rapide la cele mai comune întrebări
            </p>
          </div>

          {/* FAQ Items */}
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-md overflow-hidden transition-all"
                style={{ opacity: 1, transform: 'none' }}
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  aria-expanded={openIndex === index}
                  aria-controls={`faq-answer-${index}`}
                  className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
                >
                  <span className="font-semibold text-gray-900 pr-4">
                    {faq.question}
                  </span>
                  <div
                    className="flex-shrink-0 transition-transform duration-200"
                    style={{
                      transform: openIndex === index ? 'rotate(180deg)' : 'none'
                    }}
                  >
                    <ChevronDown className="text-teal-700" size={24} />
                  </div>
                </button>

                {/* Answer - mereu în HTML (indexabil de Google), ascuns vizual până la click */}
                <div
                  className={`px-6 pb-5 text-gray-700 ${openIndex === index ? 'animate-fade-in' : 'hidden'}`}
                  id={`faq-answer-${index}`}
                >
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
